import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Gift = createReactComponent("Gift", ["svg", defaultAttributes, [["polyline", {
  points: "20 12 20 22 4 22 4 12",
  key: "1rylk6"
}], ["rect", {
  x: "2",
  y: "7",
  width: "20",
  height: "5",
  key: "zlnt2s"
}], ["line", {
  x1: "12",
  y1: "22",
  x2: "12",
  y2: "7",
  key: "1oebls"
}], ["path", {
  d: "M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z",
  key: "2us9pr"
}], ["path", {
  d: "M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z",
  key: "17syld"
}]]]);
export default Gift;